import generic_backend_request_get from 'functions/server/generic_backend_request_get';

/**
 * Fetches a published example scenario by slug.
 *
 * The cacheable twin of `/saved_scenario` (BE #205): a GET, keyed by URL, with
 * `Cache-Control` set, and — by construction — incapable of returning anyone's
 * private data. `/saved_scenario` is a POST, so CloudFront (whose cached methods
 * are GET/HEAD) could never cache it; every gallery card open went to origin.
 *
 * Only for published examples. A user's own saved scenario still goes through
 * `get_saved_scenario`, which is authenticated and must never be cached.
 *
 * @param {string} slug - The example's published slug, e.g. "zurich-watch-repair-courier".
 * @return {Object} The scenario, in the same shape `/saved_scenario` returns.
 */
async function get_example_scenario(slug) {
    if (!slug || typeof slug !== 'string' || !slug.trim()) {
        throw new Error('A slug is required for get_example_scenario');
    }

    return generic_backend_request_get(`/example_scenario/${encodeURIComponent(slug.trim())}`);
}

export default get_example_scenario;
